import React from 'react';
import { motion } from 'framer-motion';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Persónuverndarstefna</h1>
          
          <div className="bg-white rounded-2xl p-8 shadow-sm prose max-w-none">
            <h2>1. Almennt</h2>
            <p>Vefsíða (Novamedia ehf.) leggur mikla áherslu á að vernda persónuupplýsingar viðskiptavina sinna. Þessi persónuverndarstefna útskýrir hvernig við söfnum, notum og verndum persónuupplýsingar þínar í samræmi við lög nr. 90/2018 um persónuvernd og vinnslu persónuupplýsinga.</p>

            <h2>2. Ábyrgðaraðili</h2>
            <p>Ábyrgðaraðili persónuupplýsinga er:</p>
            <ul>
              <li>Novamedia ehf.</li>
              <li>Kt. 540606-2260</li>
              <li>Netfang: hallo@vefsida.is</li>
              <li>Sími: (+354) 537-7990</li>
            </ul>

            <h2>3. Söfnun og notkun persónuupplýsinga</h2>
            <p>Við söfnum aðeins þeim persónuupplýsingum sem nauðsynlegar eru fyrir þjónustu okkar:</p>
            <ul>
              <li>Nafn</li>
              <li>Netfang</li>
              <li>Símanúmer</li>
              <li>Heimilisfang (þegar við á)</li>
              <li>Greiðsluupplýsingar (þegar við á)</li>
              <li>IP-tölur og vafraupplýsingar</li>
            </ul>

            <h2>4. Tilgangur vinnslu</h2>
            <p>Við notum persónuupplýsingar þínar til að:</p>
            <ul>
              <li>Veita umbeðna þjónustu og uppfylla samningsskyldur</li>
              <li>Svara fyrirspurnum og veita þjónustu</li>
              <li>Senda tilkynningar um þjónustu og uppfærslur</li>
              <li>Bæta þjónustu okkar og notendaupplifun</li>
              <li>Uppfylla lagalegar skyldur</li>
              <li>Koma í veg fyrir svik og misnotkun</li>
            </ul>

            <h2>5. Varðveislutími</h2>
            <p>Við geymum persónuupplýsingar þínar aðeins eins lengi og nauðsynlegt er til að uppfylla tilgang söfnunar þeirra eða eins lengi og lög og reglur kveða á um. Að þeim tíma liðnum er upplýsingunum eytt með öruggum hætti.</p>

            <h2>6. Miðlun persónuupplýsinga</h2>
            <p>Við miðlum persónuupplýsingum aðeins til þriðju aðila þegar:</p>
            <ul>
              <li>Það er nauðsynlegt til að veita umbeðna þjónustu</li>
              <li>Við erum skyldug til þess samkvæmt lögum</li>
              <li>Þú hefur veitt samþykki þitt</li>
            </ul>

            <h2>7. Öryggi persónuupplýsinga</h2>
            <p>Við notum viðeigandi tæknilegar og skipulagslegar öryggisráðstafanir til að vernda persónuupplýsingar þínar, þar á meðal:</p>
            <ul>
              <li>Dulkóðun gagna</li>
              <li>Aðgangsstýringar</li>
              <li>Reglulegt öryggiseftirlit</li>
              <li>Þjálfun starfsfólks</li>
            </ul>

            <h2>8. Réttindi þín</h2>
            <p>Þú hefur eftirfarandi réttindi varðandi persónuupplýsingar þínar:</p>
            <ul>
              <li>Rétt til aðgangs að upplýsingum</li>
              <li>Rétt til leiðréttingar</li>
              <li>Rétt til eyðingar ("réttur til að gleymast")</li>
              <li>Rétt til takmörkunar á vinnslu</li>
              <li>Rétt til að andmæla vinnslu</li>
              <li>Rétt til gagnaflutninga</li>
            </ul>

            <h2>9. Breytingar á persónuverndarstefnu</h2>
            <p>Við áskiljum okkur rétt til að uppfæra þessa persónuverndarstefnu. Allar breytingar verða tilkynntar á vefsíðu okkar og taka gildi við birtingu.</p>

            <h2>10. Samskipti og fyrirspurnir</h2>
            <p>Ef þú hefur spurningar varðandi persónuverndarstefnu okkar eða meðhöndlun persónuupplýsinga, vinsamlegast hafðu samband við okkur:</p>
            <ul>
              <li>Netfang: hallo@vefsida.is</li>
              <li>Sími: (+354) 537-7990</li>
            </ul>

            <p>Þú hefur einnig rétt til að leggja fram kvörtun hjá Persónuvernd (www.personuvernd.is) ef þú telur að vinnsla persónuupplýsinga þinna brjóti gegn lögum.</p>

            <p className="text-sm text-gray-500 mt-8">Síðast uppfært: 11. mars 2024</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Privacy;